var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * iconfont
 * spin 属性用来播放动画
 * 动画参数 SPIN，SPIN2,ALTERNATE,
 */
import React from 'react';
import classNames from 'classnames';
import { createFromIconfontCN } from '@ant-design/icons';
import * as allIcons from '@ant-design/icons/es/icons';
import './index.less';
const iconsMap = allIcons;
const Icon = (props) => {
    const { type = '', svg = false, antdIcon = false, spin, style, classname = '', className = '', prefixCls = Icon.prefixCls, rotate } = props, others = __rest(props, ["type", "svg", "antdIcon", "spin", "style", "classname", "className", "prefixCls", "rotate"]);
    const iconType = type && `${(prefixCls || '') && '-'}${type}`;
    const cls = classNames('icon', iconType || '', {
        'iconfont-spin': spin,
        // 'iconfont-spin-1': play === Icon.SPIN1,
        // 'iconfont-spin-2': play === Icon.SPIN2,
        // 'iconfont-spin-alternate': play === Icon.ALTERNATE,
    }, classname, className);
    if (antdIcon) {
        const targetIconComponent = iconsMap[type];
        if (targetIconComponent) {
            return React.createElement(targetIconComponent, Object.assign({ className: cls, style }, others));
        }
    }
    return svg ? (<svg className={cls}>
            <use xlinkHref={`#${iconType}`}/>
        </svg>) : Icon.IconFont ? (<Icon.IconFont type={iconType} className={cls} spin={spin} rotate={rotate} {...others} style={style}/>) : (<i className={cls} {...others} style={Object.assign({ transform: `rotate(${rotate || 0}deg)` }, style)}/>);
};
//循环旋转
Icon.SPIN = 'SPIN';
// 暂时不支持
Icon.SPIN1 = 'SPIN1';
Icon.SPIN2 = 'SPIN2';
//交替旋转
Icon.ALTERNATE = 'ALTERNATE';
Icon.IconFont = null;
Icon.prefixCls = 'icon';
Icon.createFromIconfontCN = (props) => {
    const { prefixCls, fontFamily } = props, otherProps = __rest(props, ["prefixCls", "fontFamily"]);
    const IconFont = createFromIconfontCN(otherProps);
    Icon.IconFont = IconFont;
    Icon.prefixCls = prefixCls;
    return IconFont;
};
export default Icon;
